import { useCallback } from 'react';
import { CapTableVersion, CapTableVersionWithCompanyId } from 'common/types/company';
import { UseStoreValue } from 'common/types/store';
import { RelatedEntity } from 'pages/ValuationsAllocation/types';
import { useGetVersionsByCompanyIdByDateId } from 'services/hooks/company';
import { Logger } from 'utilities';

const useGenerateChildrenCompaniesCapTablesVersions = (
  companyList: UseStoreValue['companyList'],
  selectedDate?: string,
  selectedCompanyId?: number
) => {
  const getCapTableVersions = useGetVersionsByCompanyIdByDateId();

  const generateChildrenCompaniesCapTablesVersions = useCallback(async () => {
    try {
      const tempCapTableVersionsByCompany: Record<string, CapTableVersionWithCompanyId[]> = {};
      const companyInfo = (companyList ?? []).find(c => c.company_id === selectedCompanyId);

      if (
        companyInfo?.child_companies &&
        companyInfo.child_companies?.length > 0 &&
        selectedCompanyId &&
        selectedDate
      ) {
        await Promise.all(
          (companyInfo.child_companies as RelatedEntity[]).map(async (child: RelatedEntity) => {
            // find same date value as the parent company and retrieve id from slug based on that
            const mdId = child?.company_measurement_dates
              .find(cmd => cmd.date === selectedDate)
              ?.slug.split('-')
              .slice(-1)
              .join('');
            const capTableVersionsForCompany = (await getCapTableVersions(
              child.company_id,
              mdId,
              true
            ) || []) as CapTableVersion[];
            tempCapTableVersionsByCompany[child.company_name] = capTableVersionsForCompany?.map(ct => ({
              ...ct,
              name: ct.name || `${child.company_name} Cap Table`,
              company_id: Number(child.company_id),
              use_custom_breakpoints: Boolean(ct.use_custom_breakpoints),
            }));
          })
        );
      }

      return tempCapTableVersionsByCompany;
    } catch (error) {
      Logger.error('Error fetching child company cap tables', error);
      return {};
    }
  }, [companyList, getCapTableVersions, selectedDate, selectedCompanyId]);

  return { generateChildrenCompaniesCapTablesVersions };
};

export default useGenerateChildrenCompaniesCapTablesVersions;
